import React from 'react';
import './index.scss';

const NextSteps = () => {
  return (
    <div className="next_section">
      <div className="other-steps">
        <h3 className="next_heading">Next Steps</h3>
        <ul className="steps-items">
          <li>
            <h4>Expect a Call</h4>
            <p>Our account manager will reach out to you for confirmation and digital KYC.</p>
          </li>
          <li>
            <h4>Order Verification</h4>
            <p>Our order verification team will process and verify the order details. We will notify you once the order is confirmed.</p>
          </li>

          <li>
            <h4>Installation</h4>
            <p>Post successful verification, internet service will be installed, activated and ready to use.</p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NextSteps;
